<template lang="html">
  <div class="cw-loader">
    <div class="hero is-large">
      <div class="hero-body has-text-centered">
        <div class="main-loader pulse-loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cw-loader',
  // share common functionality with component mixins
  mixins: [],
  props: {},
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="stylus" scoped>
.cw-loader {
  flex: 1 0 auto
  display: flex
  flex-direction: column
  align-items: center
}
.main-loader {
  margin: auto;
}
</style>
